import CommonChip from 'components/core/CommonChip'
import { ORDER_STATUS_LABELS_MAP } from 'constants/order.constants'
import { SPACING } from 'constants/spacing.constants'
import { OrderStatusType } from 'types/order.types'
import { ICONS_MAP } from './OrderStatusIcon'
import { BACKGROUND_COLORS_MAP } from './orderStatusChip.constants'
import { BORDER_COLORS_MAP } from './orderStatusChip.constants'
import { TEXT_COLORS_MAP } from './orderStatusChip.constants'

const ICON_SIZE = SPACING.p2

export type OrderStatusChipProps = {
    hasLabel?: boolean
    status: OrderStatusType
}

export const OrderStatusChip = ({
    hasLabel = true,
    status,
}: OrderStatusChipProps) => {
    const Icon = ICONS_MAP[status]

    return (
        <CommonChip
            label={hasLabel ? ORDER_STATUS_LABELS_MAP[status] : ''}
            textColor={TEXT_COLORS_MAP[status]}
            borderColor={BORDER_COLORS_MAP[status]}
            backgroundColor={BACKGROUND_COLORS_MAP[status]}
            Icon={<Icon size={ICON_SIZE} color={TEXT_COLORS_MAP[status]} />}
        />
    )
}
